import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TeachAppAndLandingColorPalette as Color } from '@lalalilo/enums';
import styled from 'styled-components';
import { NoStyleButton } from './button';
export const Switch = ({ on, onClick, ariaLabelledBy, ariaDescribedBy, localizedStrings, }) => {
    return (_jsxs(Wrapper, { children: [_jsx(Status, { children: on ? localizedStrings.on : localizedStrings.off }), _jsx(Button, Object.assign({ "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "aria-selected": on, on: on, onClick: onClick }, { children: _jsx(Toggle, { on: on }) }))] }));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
`;
const Status = styled.label `
  margin-right: 5px;
  font-size: 14px;
  color: ${Color.purple_600};
`;
const Button = styled(NoStyleButton) `
  width: 36px;
  height: 20px;
  border-radius: 11px;
  background-color: ${props => (props.on ? Color.purple_600 : Color.grey_500)};
`;
const Toggle = styled.div `
  width: 18px;
  height: 18px;
  background-color: ${Color.white};
  left: ${props => (props.on ? 17 : 1)}px;
  border-radius: 9px;
  position: relative;
  transition: left 0.2s ease-in-out;
`;
//# sourceMappingURL=Switch.js.map